import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback } from 'react';

import {
  GetWebVisitDetailDocument,
  SendCongestionNotificationForWebVisitorDocument,
} from '~/graphql/generated/graphql';
import { webVisitorNotificationCongestionModalState } from '~/state/reception/atoms';

export const useSendCongestionNotification = () => {
  const { isOpen, appointmentId, webVisitorId } = useAtomValue(
    webVisitorNotificationCongestionModalState,
  );
  const resetWebVisitorNotificationCongestionModalState = useResetAtom(
    webVisitorNotificationCongestionModalState,
  );

  const [sendNotification, { loading, error }] = useMutation(
    SendCongestionNotificationForWebVisitorDocument,
    {
      refetchQueries: [{ query: GetWebVisitDetailDocument, variables: { id: appointmentId } }],
    },
  );

  const handleSend = useCallback(
    async (content: string) => {
      if (!appointmentId || !webVisitorId || !isOpen) return;

      try {
        await sendNotification({
          variables: {
            input: {
              webVisitorId,
              content,
              appointmentId,
            },
          },
        });

        resetWebVisitorNotificationCongestionModalState();
      } catch {
        // 何もしない
      }
    },
    [
      appointmentId,
      isOpen,
      sendNotification,
      webVisitorId,
      resetWebVisitorNotificationCongestionModalState,
    ],
  );

  return { loading, error, handleSend };
};
